import { DataType, FormattingRule } from "@/types/insights"
import { FirstDayOfWeekSetting } from "./tenantSetting"
import store from "../store/index"

export interface View {
	id?: string
	tenantId: string
	title: string
	folder: string
	teams: any[]
	viewTeams: any[]
	clauses: Clause[]
	sortBy: string
	groupBy?: string | null
	groupByOption?: string | null
	sortByLabel?: string
	groupByLabel?: string | null
	columns: string[]
	groupByDataType: DataType | null
	formattingRules?: { [key: string]: FormattingRule[] }
	timeZone?: string
}

export interface Clause {
	key?: string | null
	id?: string
	field?: string
	label: string
	operator?: number | null
	dataSourceId?: string

	fieldData?: any
	fieldDataType: number

	dynamicField: boolean
	dynamicValue: boolean
	dynamicParameter?: string | null

	value?: string | null
	valueLabel?: string
	definitionId?: string
	definitionField?: string
	definitionFieldLabel?: string
	definitionFieldDataType?: number
	itemLabel?: string

	orClause?: boolean
	subClauses?: Clause[]
	isValid?: boolean

	valueObject?: any

	searchClauseParameters?: SearchClauseParameters

	userField?: string | null
	userFieldData?: any
	userFieldDataType?: number | null
}

export interface SearchClauseParameters {
	startDayOfWeek: DayOfWeek,
	weekNumber?: number,
	startDate?: Date,
	endDate?: Date,
	timeSpentClause: TimeSpentClause
	startMonthRange?: Date,
    endMonthRange?: Date
}

export interface TimeSpentClause {
	searchValue: string,
	searchLabel: string,
	hoursSpent: number,
	trackingFieldId: string
}

export enum DayOfWeek {
	Sunday = 0,
	Monday = 1,
	Tuesday = 2,
	Wednesday = 3,
	Thursday = 4,
	Friday = 5,
	Saturday = 6
}

const defaultSearchClauseParameters = {
	startDayOfWeek: DayOfWeek.Monday,
	timeSpentClause: {
		searchValue: "",
		searchLabel: "",
		hoursSpent: 0,
		trackingFieldId: ""
	}
}

function getDefaultTimeSpentClause () {
	return {
		searchValue: "",
		searchLabel: "",
		hoursSpent: 0,
		trackingFieldId: ""
	}
}

function getDefaultFirstDayOfWeek (): DayOfWeek {
	const tenantSettings = store.getters.getTenantSettings as { [key: string]: any }

	if (tenantSettings && tenantSettings["defaultFirstDayOfWeek"]) {
		const firstDayOfWeekSettings = tenantSettings["defaultFirstDayOfWeek"] as FirstDayOfWeekSetting
		if (!firstDayOfWeekSettings.enabled) {
			return DayOfWeek.Monday
		} else {
			return firstDayOfWeekSettings.dayOfWeekSelected
		}
	} else {
		return DayOfWeek.Monday
	}
}

function getDefaultSearchClauseParameters () {
	return {
		startDayOfWeek: getDefaultFirstDayOfWeek(),
		timeSpentClause: getDefaultTimeSpentClause()
	}
}

export { getDefaultTimeSpentClause, getDefaultSearchClauseParameters, defaultSearchClauseParameters }
